const QCObjects = require("./QCObjects.js");
module.exports = QCObjects;